import React from 'react';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection, ProblemSection, StakesSection, MythsSection, VisionSection, MethodSection, ProductReveal, ComparisonSection, ResultsSection, StorySection } from './components/Sections';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
export function App() {
  return <div className="min-h-screen w-full relative" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      <main className="max-w-[720px] mx-auto px-5 sm:px-8 py-8" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <StakesSection data-id="element-5" />
        <MythsSection data-id="element-6" />
        <VisionSection data-id="element-7" />
        <MethodSection data-id="element-8" />
        <ProductReveal data-id="element-9" />
        <ComparisonSection data-id="element-10" />
        <ResultsSection data-id="element-11" />
        <StorySection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <BonusSection data-id="element-14" />
        <PricingSection data-id="element-15" />

        <footer className="mt-16 pb-8 text-center text-sm text-gray-400" data-id="element-16">
          <p data-id="element-17">
            © {new Date().getFullYear()} Motricidad en Niños. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </footer>
      </main>
    </div>;
}